import { render } from "./HeroImageSplit.vue?vue&type=template&id=75948188"
const script = {}
script.render = render

export default script